import { useCallback, useMemo } from "react";
import { isNonEmptyString, isFunction, isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";


export const useFacetedSearch = ({
	availableColumns = [],
	setSearchFragments = undefined,
	searchByKey = false
}) => {
	const searchFacets = useMemo(() => {
		return isNonEmptyArray(availableColumns)
			? availableColumns.map(({ keys, id, columnHeader, type, specialKey }) => ({
				fieldKeys: [...keys],
				key: id,
				value: id,
				text: columnHeader,
				searchKey: specialKey ?? (searchByKey ? keys[0] : columnHeader),
				facetType: type
			}))
			: [];
	}, [availableColumns, searchByKey]);

	const onSearchChange = useCallback(({ facetSearch, facets }) => {
		const searchFragments = {};
		const hasSearchQuery = key => isNonEmptyString(facetSearch[key]);

		Object.keys(facetSearch)
			.filter(hasSearchQuery)
			.forEach(key => {
				const facet = facets.find(({ key: facetKey }) => facetKey === key);
				const searchKey = facet?.searchKey || undefined;

				if (searchKey) {
					searchFragments[searchKey] = facetSearch[key];
				}
			});

		if (isFunction(setSearchFragments)) {
			setSearchFragments(searchFragments);
		}

		return searchFragments;
	}, [setSearchFragments]);

	return { searchFacets, onSearchChange };
};

export default useFacetedSearch;